/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './animation008.less';

import ImgPoint from '../../../../../assets/animation_point.gif';
import arrow from '../../../../../assets/arrow.png';

interface IAnimation008Item {
  title: string;
  subtitle?: string;
  content: string;
}

const bgTemplate = [
  '#597EF7',
  '#0CA3A3',
  '#F26927',
  '#E7444E',
  '#343194',
  '#2C2281',
  '#E7444E',
  '#FFC53D',
  '#0CA3A3',
  '#0C53A3',
];

const getBG = (feed: number) => bgTemplate[feed % bgTemplate.length];

interface IAnimation008Props {
  items: IAnimation008Item[];
  title: string;
  onCompleted?: () => void;
  className?: string;
}

const Animation008: React.FunctionComponent<IAnimation008Props> = ({
  className,
  items,
  title,
  onCompleted,
}) => {
  const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const [play, setPlay] = React.useState(1);
  const [isPlayed, setIsPlayed] = React.useState(false);
  const startPlay = (next = 1) => {
    if (isPlayed) {
      return;
    }
    next += 1;
    setPlay(next);
    setIsPlayed(true);
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1000);
    } else {
      onCompleted && onCompleted();
    }
  };

  const rowCount = items.length <= 5 ? items.length : 5;

  return (
    <div ref={crrRef} className={`animation008 component ${className}`}>
      <div
        className="animation008-tip"
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <div className="animation008-content">
        {items.map((itm: IAnimation008Item, idx: number) => (
          <div
            key={idx}
            className={`animation008-item  r${idx + 1} animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            onClick={() => startPlay()}
            style={{
              width: `calc(${(1 / rowCount) * 100}% - 1rem)`,
              backgroundColor: getBG(idx),
            }}
          >
            <img
              className={`click-point ${play > 1 ? 'hide' : ''}`}
              src={ImgPoint}
              alt=""
            />
            <div className="animation008-header">
              <div className="subtitle">
                {itm.subtitle}
                <div className={`arrow r${idx + 1}`}>
                  <img src={arrow} alt="" />
                </div>
              </div>
            </div>
            {itm.title && (
              <div
                className="animation008-top"
                dangerouslySetInnerHTML={{ __html: itm.title }}
              />
            )}
            <div
              className="animation008-text"
              dangerouslySetInnerHTML={{ __html: itm.content }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Animation008;
